import { getValidClassNames } from "@/utils"
import { ContainerProps } from "./Container.interfaces"
import { ESize } from "@/interfaces/enums"

export const Container = ({ additionalClassNames, children, size = ESize.MD }: ContainerProps) => {
  return(
    <div 
    className={getValidClassNames({
      [`c-container c-container--${size}`]: true,
      [String(additionalClassNames)]: Boolean(additionalClassNames)
    })}
    >
      {children}
    </div>
  )
}